export const INSTALLATION = 'installation';
export const OTHER_EXPENSE = 'other-expense';
